'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../enums/accordion.js');
require('../enums/alert.js');
require('../enums/avatar.js');
require('../enums/breakpoints.js');
require('../enums/button.js');
require('../enums/code-editor.js');
require('../enums/colors.js');
require('../enums/combobox.js');
require('../enums/date.js');
require('../enums/drag-and-drop.js');
require('../enums/dialog.js');
require('../enums/divider.js');
require('../enums/dropdown.js');
require('../enums/fieldset.js');
require('../enums/font-icon.js');
require('../enums/fonts.js');
require('../enums/headings.js');
require('../enums/input.js');
var keys = require('../enums/keys.js');
require('../enums/list.js');
require('../enums/listbox.js');
require('../enums/loader.js');
require('../enums/margin.js');
require('../enums/option.js');
require('../enums/pill.js');
require('../enums/placements.js');
require('../enums/popout.js');
require('../enums/privacy.js');
require('../enums/radio-group.js');
require('../enums/status.js');
require('../enums/switch.js');
require('../enums/table.js');
require('../enums/tooltip.js');
require('../enums/transitions.js');
require('../enums/widths.js');

const comboboxInputKeys = [
    'ArrowUp',
    'ArrowDown',
    'End',
    'Home'
];
const comboboxDivKeys = [
    ' ',
    'Space',
    'ArrowUp',
    'ArrowDown',
    'End',
    'Home'
];
const keyMap = {
    [keys.Keysets.ComboboxDiv]: comboboxDivKeys,
    [keys.Keysets.ComboboxInput]: comboboxInputKeys
};
const preventKeyboardScrollingKeyboardEvent = (e, keyset = keys.Keysets.ComboboxDiv)=>{
    if (keyMap[keyset].includes(e.key)) {
        e.preventDefault();
    }
};
/**
 * Prevent the window from scrolling when using a keyboard to arrow down and up inside of a listbox.
 *
 * @returns void
 */ const usePreventKeyboardScrolling = (keyset = keys.Keysets.ComboboxDiv)=>{
    React.useEffect(()=>{
        const listener = (e)=>preventKeyboardScrollingKeyboardEvent(e, keyset);
        window.addEventListener('keydown', listener, false);
        return ()=>window.removeEventListener('keydown', listener);
    });
};

exports.preventKeyboardScrollingKeyboardEvent = preventKeyboardScrollingKeyboardEvent;
exports.usePreventKeyboardScrolling = usePreventKeyboardScrolling;
//# sourceMappingURL=use-prevent-keyboard-scrolling.js.map
